/**
 * Cart page + drawer: wishlist panel via entry button (not header tabs).
 */
(function () {
  const STORAGE_KEY = 'onhow-wishlist';

  function getWishlist() {
    try {
      const items = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(items) ? items : [];
    } catch {
      return [];
    }
  }

  function saveWishlist(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    if (window.onhowWishlist && typeof window.onhowWishlist.updateWishlistCount === 'function') {
      window.onhowWishlist.updateWishlistCount();
    }
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function escapeAttr(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;');
  }

  function wishlistImageUrl(url) {
    if (!url) return '';
    let normalized = url.startsWith('//') ? 'https:' + url : url;
    if (normalized.includes('width=')) {
      return normalized.replace(/width=\d+/, 'width=400');
    }
    return normalized + (normalized.includes('?') ? '&' : '?') + 'width=400';
  }

  function renderWishlistItemsMarkup(items) {
    return items
      .map((item) => {
        const title = item.title || '';
        const titleHtml = escapeHtml(title);
        const titleAttr = escapeAttr(title);
        const priceHtml = escapeHtml(item.price);
        const urlAttr = escapeAttr(item.url);
        const urlHtml = escapeHtml(item.url);
        const image = escapeHtml(wishlistImageUrl(item.image));
        const idAttr = escapeAttr(item.id || '');

        return `
          <li class="cart-wishlist-item wishlist-item" data-product-id="${idAttr}" data-product-title="${titleAttr}" data-product-url="${urlAttr}">
            <a href="${urlHtml}" class="cart-wishlist-item__media">
              <img src="${image}" alt="${titleHtml}" loading="lazy" decoding="async" width="112" height="149">
            </a>
            <div class="cart-wishlist-item__body">
              <div class="cart-wishlist-item__details">
                <a href="${urlHtml}" class="cart-wishlist-item__title">${titleHtml}</a>
                <p class="cart-wishlist-item__price">${priceHtml}</p>
              </div>
              <div class="cart-wishlist-item__actions">
                <button type="button" class="cart-wishlist-item__add add-to-cart-btn">Add to cart</button>
                <button type="button" class="cart-wishlist-item__remove" aria-label="Remove from wishlist">Remove</button>
              </div>
            </div>
          </li>
        `;
      })
      .join('');
  }

  class SkippWishlistView {
    constructor(config) {
      this.context = config.context;
      this.root = config.root;
      this.wishlistPanel = document.getElementById(config.wishlistPanelId);
      this.wishlistList = document.getElementById(config.wishlistListId);
      this.emptyEl = config.emptyElId ? document.getElementById(config.emptyElId) : null;
      this.cartContent = config.cartContentId ? document.getElementById(config.cartContentId) : null;
      this.cartPanel = config.cartPanelId ? document.getElementById(config.cartPanelId) : null;
      this.headerTitleEl = config.headerTitleId ? document.getElementById(config.headerTitleId) : null;
      this.cartWarnings = config.cartWarningsSelector
        ? this.root.querySelector(config.cartWarningsSelector)
        : null;
      this.activeView = 'cart';
      this.viewClass = config.viewClass;
      this.defaultHeaderTitle = config.defaultHeaderTitle || 'MY BAG';
      this.wishlistHeaderTitle = config.wishlistHeaderTitle || 'WISHLIST';

      if (!this.root || !this.wishlistPanel || !this.wishlistList) {
        this.ready = false;
        return;
      }

      this.ready = true;
      this.applyView('cart');
      this.updateEntryCounts();
    }

    syncHeaderTabs(isWishlist) {
      const bagTab = this.root.querySelector('[data-cart-show-bag]');
      const wishTab = this.root.querySelector('[data-cart-show-wishlist]');
      if (bagTab) {
        bagTab.classList.toggle('is-active', !isWishlist);
        bagTab.setAttribute('aria-selected', isWishlist ? 'false' : 'true');
      }
      if (wishTab) {
        wishTab.classList.toggle('is-active', isWishlist);
        wishTab.setAttribute('aria-selected', isWishlist ? 'true' : 'false');
      }
      if (this.headerTitleEl) {
        this.headerTitleEl.textContent = isWishlist ? this.wishlistHeaderTitle : this.defaultHeaderTitle;
      }
    }

    applyView(view) {
      if (!this.ready) return;

      const isWishlist = view === 'wishlist';
      this.activeView = isWishlist ? 'wishlist' : 'cart';

      this.root.classList.toggle(this.viewClass, isWishlist);
      this.syncHeaderTabs(isWishlist);

      if (this.context === 'page') {
        if (this.cartContent) {
          this.cartContent.classList.toggle('is-active', !isWishlist);
        }
        this.wishlistPanel.classList.toggle('is-active', isWishlist);
        this.wishlistPanel.setAttribute('aria-hidden', isWishlist ? 'false' : 'true');
      } else {
        if (this.cartPanel) {
          this.cartPanel.hidden = isWishlist;
        }
        this.wishlistPanel.hidden = !isWishlist;
        this.wishlistPanel.setAttribute('aria-hidden', isWishlist ? 'false' : 'true');
        this.wishlistPanel.classList.toggle('is-active', isWishlist);
      }

      if (this.cartWarnings) {
        this.cartWarnings.style.display = isWishlist ? 'none' : '';
      }

      if (isWishlist) {
        this.renderWishlist();
      }
    }

    showWishlist() {
      this.applyView('wishlist');
    }

    showCart() {
      this.applyView('cart');
    }

    renderWishlist() {
      if (!this.ready) return;

      const wishlistItems = getWishlist();

      if (wishlistItems.length === 0) {
        this.wishlistList.innerHTML = '';
        this.wishlistList.hidden = true;
        if (this.emptyEl) {
          this.emptyEl.hidden = false;
        }
        return;
      }

      if (this.emptyEl) {
        this.emptyEl.hidden = true;
      }
      this.wishlistList.hidden = false;
      this.wishlistList.innerHTML = renderWishlistItemsMarkup(wishlistItems);
    }

    updateEntryCounts() {
      const count = getWishlist().length;
      this.root.querySelectorAll('.cart-wishlist-entry__count, .skipp-cart-header-tabs__count').forEach((el) => {
        el.textContent = count > 0 ? String(count) : '';
      });
    }

    removeItem(productTitle, productId) {
      const wishlistItems = getWishlist().filter((item) => {
        if (productId && item.id && String(item.id) === String(productId)) return false;
        return item.title !== productTitle;
      });
      saveWishlist(wishlistItems);
      this.renderWishlist();
      this.updateEntryCounts();
      notifyWishlistChanged();
    }

    refreshCartAfterAdd() {
      if (this.context === 'drawer') {
        const drawerItems = document.querySelector('cart-drawer-items');
        if (drawerItems && typeof drawerItems.refreshDrawerFromServer === 'function') {
          return drawerItems.refreshDrawerFromServer();
        }
        return Promise.resolve();
      }

      const cartItemsEl = document.querySelector('cart-items');
      if (cartItemsEl && typeof cartItemsEl.onCartUpdate === 'function') {
        return cartItemsEl.onCartUpdate();
      }
      return Promise.resolve();
    }

    addToCart(button, productUrl, productTitle, productId) {
      button.disabled = true;

      fetch(productUrl)
        .then((response) => response.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const form =
            doc.querySelector('form[action="/cart/add"]') || doc.querySelector('form[action^="/cart/add"]');
          if (!form) throw new Error('Add to cart form not found');

          const formData = new FormData(form);

          if (this.context === 'drawer') {
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
              formData.append(
                'sections',
                cartDrawer.getSectionsToRender().map((section) => section.id)
              );
              formData.append('sections_url', window.location.pathname);
              if (typeof cartDrawer.setActiveElement === 'function') {
                cartDrawer.setActiveElement(button);
              }
            }
          }

          const config =
            typeof fetchConfig === 'function'
              ? fetchConfig('javascript')
              : { method: 'POST', headers: { Accept: 'application/javascript' } };
          config.headers = config.headers || {};
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];
          config.body = formData;

          const addUrl = window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add';
          return fetch(addUrl, config);
        })
        .then((response) => response.json())
        .then((data) => {
          if (data.status) throw new Error(data.description || data.message || 'Unable to add to cart');

          const wishlistItems = getWishlist().filter((item) => {
            if (productId && item.id && String(item.id) === String(productId)) return false;
            return item.title !== productTitle;
          });
          saveWishlist(wishlistItems);
          notifyWishlistChanged();

          if (this.context === 'drawer' && data.sections && data.sections['cart-drawer']) {
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
              cartDrawer.renderContents(data);
            }
          } else {
            return this.refreshCartAfterAdd();
          }
        })
        .then(() => {
          reattachViews();
          document.dispatchEvent(new CustomEvent('skipp:cart-ui-refreshed'));
          if (pageView) pageView.showCart();
          if (drawerView) drawerView.showCart();
        })
        .catch((error) => {
          console.error('Error adding product to cart:', error);
        })
        .finally(() => {
          button.disabled = false;
        });
    }

    addRecToCart(button) {
      const variantId = button.dataset.variantId;
      if (!variantId || button.disabled) return;

      button.disabled = true;
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');

      const config =
        typeof fetchConfig === 'function'
          ? fetchConfig('javascript')
          : { method: 'POST', headers: { Accept: 'application/javascript' } };
      config.headers = config.headers || {};
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = formData;

      const addUrl = window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add';

      fetch(addUrl, config)
        .then((response) => response.json())
        .then((data) => {
          if (data.status) throw new Error(data.description || data.message || 'Unable to add to cart');
          button.textContent = 'Added';
          return this.refreshCartAfterAdd();
        })
        .then(() => {
          reattachViews();
          document.dispatchEvent(new CustomEvent('skipp:cart-ui-refreshed'));
          if (pageView) pageView.showCart();
          if (drawerView) drawerView.showCart();
        })
        .catch((error) => {
          console.error('Error adding recommendation to cart:', error);
        })
        .finally(() => {
          setTimeout(() => {
            button.disabled = false;
            if (button.textContent === 'Added') {
              button.textContent = button.dataset.defaultLabel || 'Add to bag';
            }
          }, 1800);
        });
    }

    onListClick(event) {
      const addBtn = event.target.closest('.cart-wishlist-item__add');
      if (addBtn) {
        const row = addBtn.closest('.cart-wishlist-item');
        if (!row) return;
        event.preventDefault();
        this.addToCart(addBtn, row.dataset.productUrl, row.dataset.productTitle, row.dataset.productId);
        return;
      }

      const removeBtn = event.target.closest('.cart-wishlist-item__remove');
      if (removeBtn) {
        const row = removeBtn.closest('.cart-wishlist-item');
        if (!row) return;
        event.preventDefault();
        this.removeItem(row.dataset.productTitle, row.dataset.productId);
      }
    }
  }

  let pageView = null;
  let drawerView = null;
  let listenersBound = false;

  function notifyWishlistChanged() {
    document.dispatchEvent(new CustomEvent('skipp:wishlist-updated'));
  }

  function syncAllViews() {
    if (pageView && pageView.ready) {
      pageView.updateEntryCounts();
      if (pageView.activeView === 'wishlist') pageView.renderWishlist();
    }
    if (drawerView && drawerView.ready) {
      drawerView.updateEntryCounts();
      if (drawerView.activeView === 'wishlist') drawerView.renderWishlist();
    }
  }

  function reattachViews() {
    const pageViewState = pageView ? pageView.activeView : 'cart';
    const drawerViewState = drawerView ? drawerView.activeView : 'cart';

    pageView = null;
    drawerView = null;
    initViews();

    if (pageView && pageViewState === 'wishlist') {
      pageView.showWishlist();
    }
    if (drawerView && drawerViewState === 'wishlist') {
      drawerView.showWishlist();
    }
  }

  function initViews() {
    const cartItems = document.querySelector('cart-items');
    if (cartItems && document.getElementById('cart-wishlist-content')) {
      pageView = new SkippWishlistView({
        context: 'page',
        root: cartItems,
        wishlistPanelId: 'cart-wishlist-content',
        wishlistListId: 'cart-wishlist-list',
        emptyElId: 'cart-wishlist-empty',
        cartContentId: 'cart-content',
        cartWarningsSelector: '.cart__warnings',
        viewClass: 'cart-items--wishlist-view',
      });
    }

    const drawer = document.querySelector('cart-drawer');
    if (drawer && document.getElementById('cart-drawer-wishlist-content')) {
      drawerView = new SkippWishlistView({
        context: 'drawer',
        root: drawer,
        wishlistPanelId: 'cart-drawer-wishlist-content',
        wishlistListId: 'cart-drawer-wishlist-list',
        emptyElId: 'cart-drawer-wishlist-empty',
        cartPanelId: 'cart-drawer-cart-panel',
        headerTitleId: 'cart-drawer-heading',
        viewClass: 'cart-drawer--wishlist-view',
      });
    }
  }

  function viewsNeedReattach() {
    if (document.getElementById('cart-drawer-wishlist-content') && (!drawerView?.ready || !drawerView.wishlistPanel?.isConnected)) {
      return true;
    }
    if (document.getElementById('cart-wishlist-content') && (!pageView?.ready || !pageView.wishlistPanel?.isConnected)) {
      return true;
    }
    return false;
  }

  function bindGlobalListeners() {
    if (listenersBound) return;
    listenersBound = true;

    document.addEventListener('click', (event) => {
      if (event.target.closest('[data-cart-show-wishlist]')) {
        event.preventDefault();
        if (pageView && pageView.ready) pageView.showWishlist();
        if (drawerView && drawerView.ready) drawerView.showWishlist();
        return;
      }

      if (event.target.closest('[data-cart-show-bag]')) {
        event.preventDefault();
        if (pageView && pageView.ready) pageView.showCart();
        if (drawerView && drawerView.ready) drawerView.showCart();
        return;
      }

      const recAdd = event.target.closest('[data-wishlist-rec-add]');
      if (recAdd && pageView && pageView.ready && pageView.activeView === 'wishlist') {
        event.preventDefault();
        pageView.addRecToCart(recAdd);
        return;
      }

      if (event.target.closest('#cart-wishlist-list') && pageView && pageView.ready) {
        pageView.onListClick(event);
        return;
      }

      if (event.target.closest('#cart-drawer-wishlist-list') && drawerView && drawerView.ready) {
        drawerView.onListClick(event);
      }
    });

    document.addEventListener('skipp:wishlist-updated', syncAllViews);

    document.addEventListener('skipp:show-wishlist-panel', () => {
      if (pageView && pageView.ready) pageView.showWishlist();
      if (drawerView && drawerView.ready) drawerView.showWishlist();
    });

    let reattachTimer = null;
    function scheduleCartUiRefresh() {
      clearTimeout(reattachTimer);
      reattachTimer = setTimeout(() => {
        if (viewsNeedReattach()) {
          reattachViews();
        } else {
          syncAllViews();
        }
      }, 80);
    }

    document.addEventListener('skipp:cart-ui-refreshed', scheduleCartUiRefresh);

    document.addEventListener('cart:updated', () => {
      scheduleCartUiRefresh();
    });
  }

  bindGlobalListeners();
  document.addEventListener('DOMContentLoaded', initViews);
  if (document.readyState !== 'loading') {
    initViews();
  }
})();
